import apiEndpoints from '../../const/apiEndpoints'
import api from '../../services'
import { createAsyncThunk } from '@reduxjs/toolkit'
import {
  Material,
  GetMaterialsPayload,
  UnPublishMaterialPayload,
  saveMaterialAccessPayload
} from './types'
import ROUTES from '../../const/routes'
import history from '../../const/history'
import { getClearMaterial } from '../learnSession/api'

export const getMaterialsWithPublishStatus = createAsyncThunk(
  'material/getMaterialsWithPublishStatus',
  async ({
    topicId,
    batchId
  }: GetMaterialsPayload, { dispatch }): Promise<Array<Material>> => {
    const response = await api.get(
      `${apiEndpoints.getMaterialsWithPublishStatus}?topicId=${topicId}&batchId=${batchId}`
    )
    if (response.data) {
      dispatch(getClearMaterial())
    }
    return response?.data
  }
)

export const unPublishMaterial = createAsyncThunk(
  'material/unPublishMaterial',
  async ({
    materialId,
    batchId
  }: UnPublishMaterialPayload): Promise<Array<Material>> => {
    const { data } = await api.put(
      `${apiEndpoints.unPublishMaterial}?materialId=${materialId}&batchId=${batchId}`
    )

    if (data) {
      alert('UnPublished Successfully')
      history.push(ROUTES.PUBLISH_LIST)
    }

    return data
  }
)

export const saveMaterialAccess = createAsyncThunk(
  'material/saveMaterialAccess',
  async (requestData: saveMaterialAccessPayload, { dispatch }): Promise<Array<Material>> => {
    const { data } = await api.post(
      `${apiEndpoints.saveMaterialAccess}`,
      requestData
    )

    if (data.data) {
      dispatch(getClearMaterial())
      alert('Published Successfully')
      history.push(ROUTES.PUBLISH_LIST)
    }

    return data
  }
)
